import { dateSQLformat } from "../../../../functions/dateSQLformat";
import { columnsToSheet, saveXlsx } from "../../../../functions/excelWriter";

export const exportExcelChklPorDia = (data, dateFrom, dateTo) => {
  //definimos las columnas
  const columns = [
    {
      header: "Id",
      key: "id_resultado_chk",
      width: 10,
    },
    {
      header: "Maquinista",
      key: "maquinista",
      width: 30,
    },
    {
      header: "Maquina",
      key: "interno_maq",
      width: 15,
    },
    {
      header: "Tipo Maq",
      key: "tipo_maq",
      width: 25,
    },
    {
      header: "Marca",
      key: "marca",
      width: 25,
    },
    {
      header: "Modelo",
      key: "modelo",
      width: 25,
    },
    {
      header: "Fecha",
      key: "fecha",
      width: 25,
    },
    {
      header: "Fecha-Fin",
      key: "fecha_fin",
      width: 25,
    },
    {
      header: "Cierre Automatico",
      key: "fechaCoincide",
      width: 5,
    },
    {
      header: "Horas de uso",
      key: "horas_uso_fin",
      width: 20,
    },
    {
      header: "Observaciones",
      key: "observaciones_detalle",
      width: 40,
    },
    {
      header: "Otras obs.",
      key: "otras_obs",
      width: 40,
    },
    {
      header: "Depósito",
      key: "deposito",
      width: 25,
    },
    {
      header: "Estado",
      key: "chk_cerrada",
      width: 15,
    },
  ];
  // Definimos las filas
  const rows = data.map((item) => ({
    ...item,
    fecha: dateSQLformat(item.fecha, "addTime"),
    fecha_fin: dateSQLformat(item.fecha_fin, "addTime"),
    fechaCoincide: item.fechaCoincide ? "Si" : "No",
    horas_uso_fin: item.horas_uso_fin ? item.horas_uso_fin : item.horas_uso,
    chk_cerrada: item.chk_cerrada ? "Cerrada" : "Abierta",
  }));
  const sheet = columnsToSheet(columns, rows);
  return saveXlsx(
    [{ ...sheet, sheet: "Informe Checklists" }],
    `Informe checklists ${dateFrom} - ${dateTo}`
  );
};
